/***流动线 */
import { loadModules } from "esri-loader";
import echartsLayer from "./echartsLayer";

export class FlowLine {
  private static intances: Map<string, any>;
  private view!: any;
  private echartlayer: any;
  private watchHandler: any;
  private colors: Array<string> = [
    "rgba(0,255,255,0.4)",
    "rgba(255,255,0,0.4)",
    "rgba(255,215,0,0.4)",
    "rgba(255,69,0,0.4)",
    "rgba(0,250,154,0.4)",
    "rgba(0,255,0,0.4)",
    "rgba(255,0,0,0.4)",
    "rgba(255,20,147,0.4)",
    "rgba(0,191,255,0.4)",
  ];

  private constructor(view: any) {
    this.view = view;
  }
  public static getInstance(view: __esri.MapView | __esri.SceneView) {
    let id = view.container.id;
    if (!FlowLine.intances) {
      FlowLine.intances = new Map();
    }
    let intance = FlowLine.intances.get(id);
    if (!intance) {
      intance = new FlowLine(view);
      FlowLine.intances.set(id, intance);
    }
    return intance;
  }
  public static destroy() {
    (FlowLine.intances as any) = null;
  }

  public async hideFlowLine() {
    this.clear();
  }
  private clear() {
    if (this.echartlayer) {
      //this.view.map.remove(this.echartlayer);
      this.echartlayer.removeLayer();
      this.echartlayer = null;
    }
  }

  private getColor(alph: number): string {
    let color = "rgb(255,255,255)";
    let r = Math.floor(Math.random() * 255);
    let g = Math.floor(Math.random() * 255);
    let b = Math.floor(Math.random() * 255);
    let a = alph;
    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
  }
  public async showFlowLine() {
    let _this = this;
    //let res = await this.doQueryTask();
    let res = await this.doIdentifyTask().then((res: any) => {
      console.log(res);
      _this.showPathChart(res);
    });
    if (!this.watchHandler) {
      this.watchHandler = this.view.watch("zoom", (newValue: any) => {
        this.showFlowLine();
      });
      console.log("watch zoom");
    }
  }

  private async showPathChart(res: any) {
    this.clear();
    let chartslines: any[] = [];
    res.forEach((graphic: any, index: number) => {
      let fields = graphic.attributes;
      let tflow = 10000;
      let geometry = graphic.geometry;
      if (geometry.paths) {
        geometry.paths.forEach((item: any) => {
          let line: { coords?: any; lineStyle?: any; value?: number } = {};
          line.value = tflow;
          line.lineStyle = {
            normal: {
              color: "rgba(0,255,215,0.6)",
              width: 0,
              opacity: 0.1,
            },
          };
          line.coords = item;
          chartslines.push(line);
        });
      }
    });

    let series = [
      // {
      //   type: 'lines',
      //   coordinateSystem: 'arcgis',
      //   polyline: true,
      //   data: chartslines,
      //   silent: true,
      //   smooth: true,
      //   lineStyle: {
      //     // color: '#c23531',
      //     // color: 'rgb(200, 35, 45)',
      //     opacity: 0.1
      //     //width: 4
      //   },
      //   progressiveThreshold: 500,
      //   progressive: 200
      // },
      {
        type: "lines",
        coordinateSystem: "arcgis",
        polyline: true,
        data: chartslines,
        smooth: true,
        lineStyle: {
          width: 0,
        },
        effect: {
          constantSpeed: 60,
          period: 60,
          show: true,
          trailLength: 0.4, //小尾巴长度0.2
          symbolSize: 4,
        },
        zlevel: 1,
      },
    ];
    this.echartlayer = new echartsLayer(this.view, { wkid: 3857 });
    var option = {
      series: series,
    };
    this.echartlayer.setChartOption(option);
  }
  private async doQueryTask() {
    let _this = this;
    let res: any[] = [];
    let alllayers = _this.view.map.allLayers;
    for (let x = 0; x < alllayers.length; x++) {
      let layer = alllayers.getItemAt(x);
      if (layer.type == "imagery" || layer.type == "map-image") {
        for (let i = 0; i < layer.allSublayers.length; i++) {
          let sublayer = layer.allSublayers.getItemAt(i);
          if (!sublayer.sublayers) {
            let slayer = await sublayer.queryFeatures();
            if (slayer.geometryType == "polyline") {
              res = res.concat(slayer.features);
            }
          }
        }
      } else if (layer.type === "feature") {
        let slayer = await layer.queryFeatures();
        if (slayer.geometryType == "polyline") {
          res = res.concat(slayer.features);
        }
      }
    }
    return res;
  }
  private async doIdentifyTask() {
    let layers = this.view.map.allLayers.filter((layer: any) => {
      if (layer.visible && layer.showFlow) {
        return true;
      }
      return false;
    });
    let that = this;
    type MapModules = [
      typeof import("esri/Graphic"),
      typeof import("esri/tasks/IdentifyTask"),
      typeof import("esri/tasks/support/IdentifyParameters")
    ];
    const [Graphic, IdentifyTask, IdentifyParameters] = await (loadModules([
      "esri/Graphic",
      "esri/tasks/IdentifyTask",
      "esri/tasks/support/IdentifyParameters",
    ]) as Promise<MapModules>);
    let promises: any = layers.toArray().map((layer: any) => {
      return new Promise((resolve, reject) => {
        let identify = new IdentifyTask(layer.url); //创建属性查询对象

        let identifyParams = new IdentifyParameters(); //创建属性查询参数
        identifyParams.tolerance = 3;
        identifyParams.layerIds = [0, 1, 2, 3, 4, 5, 6, 7, 8];
        identifyParams.layerOption = "visible"; //"top"|"visible"|"all"
        identifyParams.width = that.view.width;
        identifyParams.height = that.view.height;
        identifyParams.geometry = that.view.extent;
        identifyParams.returnGeometry = true;
        identifyParams.mapExtent = that.view.extent;

        // 执行查询对象
        identify.execute(identifyParams).then((data: any) => {
          let results = data.results.map((item: any) => {
            return item.feature;
          });
          if (results.length < 1) {
            resolve(undefined);
          } else {
            resolve(results);
          }
        });
      });
    });
    return new Promise((resolve) => {
      let allRes: any[] = [];
      Promise.all(promises).then((result: any) => {
        result.forEach((el: any) => {
          allRes = allRes.concat(el);
        });
        resolve(allRes);
      });
    });
  }
}
